import { GET_USER_LOCATION } from './actions';

export default function userLocation(state = null, action) {
    switch (action.type) {
    case GET_USER_LOCATION: {
        const { coords } = action.position;
        if (!coords) {
            return null;
        }

        return {
            lat: coords.latitude,
            lng: coords.longitude,
        };
    }

    default:
        return state;
    }
}
